import { memo, ReactNode } from 'react';
import { Skeleton } from '@/components/ui/skeleton';

interface AppLayoutSkeletonProps {
  children?: ReactNode;
}

const SIDEBAR_GROUPS = [4, 3, 1, 1] as const;

export const AppLayoutSkeleton = memo<AppLayoutSkeletonProps>(({ children }) => {
  return (
    <div className="min-h-screen w-full bg-background relative">
      {/* Header shell */}
      <div className="fixed top-6 left-0 right-0 z-50 flex justify-center px-4">
        <div className="flex items-center gap-3 max-w-lg w-full">
          <Skeleton className="h-12 w-12 rounded-xl shrink-0" />
          <Skeleton className="flex-1 h-12 rounded-xl" />
          <Skeleton className="h-12 w-12 rounded-xl shrink-0" />
        </div>
      </div>

      {/* Sidebar shell */}
      <div className="fixed left-0 top-24 z-30 w-20 h-[calc(100vh-6rem)] pl-6 flex flex-col gap-[2.5vh]">
        {SIDEBAR_GROUPS.map((count, groupIdx) => (
          <div key={groupIdx} className="flex flex-col gap-[0.8vh]">
            {Array.from({ length: count }, (_, i) => (
              <Skeleton
                key={i}
                className="min-h-8 h-[5vh] max-h-12 w-12 rounded-xl"
              />
            ))}
          </div>
        ))}
      </div>

      {/* Main content area */}
      <div className="pt-24 ml-20">
        {children}
      </div>
    </div>
  );
});

AppLayoutSkeleton.displayName = 'AppLayoutSkeleton';
